module.exports = __webpack_public_path__ + "static/media/greenhouse3-10.fd5667ff.webp";